import { NotifyHelper } from "../../../../helpers/toast";
import { eDeThiInActionsObj } from "../../../action-types/de-thi/de-thi-in/IDeThiInActions";
import { generateActionForKey, generateActions } from "../../generateActions";

export const deThiInAction = {
  ...generateActions(eDeThiInActionsObj, "DE_THI_IN"),
  ...generateActionForKey(
    eDeThiInActionsObj,
    "DE_THI_IN",
    "SAVE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã cập nhật");
    }
  ),
  ...generateActionForKey(
    eDeThiInActionsObj,
    "DE_THI_IN",
    "SAVE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eDeThiInActionsObj,
    "DE_THI_IN",
    "DELETE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã xóa");
    }
  ),
  ...generateActionForKey(
    eDeThiInActionsObj,
    "DE_THI_IN",
    "DELETE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eDeThiInActionsObj,
    "DE_THI_IN",
    "CHANGE_SU_DUNG_SUCCESS",
    () => {
      NotifyHelper.Success("Đã chuyển thành công");
    }
  ),
  ...generateActionForKey(
    eDeThiInActionsObj,
    "DE_THI_IN",
    "CHANGE_SU_DUNG_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eDeThiInActionsObj,
    "DE_THI_IN",
    "DELETE_MULTIPLE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã xóa");
    }
  ),
  ...generateActionForKey(
    eDeThiInActionsObj,
    "DE_THI_IN",
    "DELETE_MULTIPLE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eDeThiInActionsObj,
    "DE_THI_IN",
    "PROGRESS_SUCCESS",
    () => {
      NotifyHelper.Success("Thành công");
    }
  ),
  ...generateActionForKey(
    eDeThiInActionsObj,
    "DE_THI_IN",
    "PROGRESS_ERRR",
    () => {
      NotifyHelper.Error("Thất bại");
    }
  ),
};
